import React, { useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import './CursorGlow.css';

/**
 * CursorGlow — a soft, spring-trailed radial glow that follows the pointer.
 * Pointer-events disabled; hidden on touch devices and for reduced motion
 * (handled in CSS). Sits behind content via blend mode so it stays subtle.
 */
const CursorGlow = () => {
  const x = useMotionValue(-400);
  const y = useMotionValue(-400);
  const sx = useSpring(x, { stiffness: 120, damping: 20, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 120, damping: 20, mass: 0.4 });

  useEffect(() => {
    const onMove = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, [x, y]);

  return <motion.div className="cursor-glow" style={{ left: sx, top: sy }} aria-hidden="true" />;
};

export default CursorGlow;
